import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import {
    AtualizaEquipeVendasController,
    GetEquipesDeVendasController,
    InsereEquipeVendasController,
    ListarEquipesDeVendasController,
} from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";
import { FormatterCPF } from "../../../../Validations/InputMasks";

interface ICriarEquipeDeVendasFormData {
    ID_EQUIPE_VENDAS: number;
    DS_EQUIPE_VENDAS: string;
    FL_ATENDIMENTO_CHAT: boolean;
    DS_NOME_CHAT: string;
    DS_NOME_EQUIPE: string;
    DS_NOME_FANTASIA: string;
    NR_CNPJ: string;
    DS_PAIS: string;
    DS_ESTADO: string;
    DS_CIDADE: string;
    DS_BAIRRO: string;
    DS_LOGRADOURO: string;
    DS_CEP: string;
    NR_NUMERO: number;
    DS_COMPLEMENTO: string;
    FL_EQUIPE_GA: boolean;
    ID_CHAVE_ERP: string;
    DS_CRECI: string;
    DS_EMAIL: string;
    NR_TELEFONE: string;
}
interface ICriarEquipeDeVendasProps {
    idEquipeVendas?: number;
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export function CriarEquipeDeVendas(props: ICriarEquipeDeVendasProps) {
    const FormMethods = useForm();
    const { reset } = FormMethods;

    const { execute: vincularEquipeVenda, loading: vincularEquipeLoading } =
        useAsyncCallback(InsereEquipeVendasController, []);

    const { value: getEquipeVendas } = useAsyncEffect(() =>
        GetEquipesDeVendasController(props.idEquipeVendas ?? 0)
    );

    const {
        execute: atualizaEquipeVendas,
        loading: atualizaEquipeVendasLoading,
    } = useAsyncCallback(AtualizaEquipeVendasController, []);

    const handleTipoCanalAtendimentoFormSubmit = (
        formData: ICriarEquipeDeVendasFormData
    ) => {
        if (props.idEquipeVendas) {
            atualizaEquipeVendas({
                ...formData,
                ID_EQUIPE_VENDAS: props.idEquipeVendas,
            }).then(() => {
                AlertConfirmation(
                    "Equipe Alterada com Sucesso",
                    "",
                    "success",
                    { cancelButtonText: false, confirmButtonText: false }
                );
                props.updateList();
                props.setShow(false);
            });
        } else {
            vincularEquipeVenda({
                ...formData,
                ID_EQUIPE_VENDAS: props.idEquipeVendas ?? 0,
            }).then(() => {
                updateListaTipoCanalAtendimento();
                props.updateList();
                props.setShow(false);
            });
        }
        reset();
    };

    function updateListaTipoCanalAtendimento() {
        ListarEquipesDeVendasController();
    }
    return (
        <>
            <div>
                <UnForm handleSubmit={handleTipoCanalAtendimentoFormSubmit}>
                    <div className="col-12 row mt-5 d-flex justify-content-between align-items-center">
                        <div className="col-4">
                            <UnForm.Input
                                name="DS_EQUIPE_VENDAS"
                                label="Nome"
                                required
                                defaultValue={getEquipeVendas?.DS_EQUIPE_VENDAS}
                            ></UnForm.Input>
                        </div>
                        <div className="col-4">
                            <UnForm.Input
                                name="ID_CHAVE_ERP"
                                label="Chave ERP"
                                defaultValue={getEquipeVendas?.ID_CHAVE_ERP}
                            ></UnForm.Input>
                        </div>
                        <div className="col-4">
                            <UnForm.Input
                                name="DS_NOME_CHAT"
                                label="Chat"
                                defaultValue={getEquipeVendas?.DS_NOME_CHAT}
                            ></UnForm.Input>
                        </div>

                        <div className="col-12 mt-5 d-flex align-items-center justify-content-center">
                            <UnForm.Switch
                                color="primary"
                                wrapperClassName="col-6 col-lg-4 mt-2"
                                label="Gerenciar Equipe"
                                labelPosition="top"
                                type="checkbox"
                                name="FL_EQUIPE_GA"
                                defaultChecked={getEquipeVendas?.FL_EQUIPE_GA}
                            />
                            <UnForm.Switch
                                wrapperClassName="col-6 col-lg-4 mt-2"
                                color="primary"
                                label="Chat?"
                                labelPosition="top"
                                type="checkbox"
                                name="FL_ATENDIMENTO_CHAT"
                                defaultChecked={
                                    getEquipeVendas?.FL_ATENDIMENTO_CHAT
                                }
                            />
                        </div>

                        <div className="mt-8 d-flex justify-content-center align-items-center">
                            <h5 className="text-center">
                                DADOS DA IMOBILIÁRIA
                            </h5>
                        </div>
                        <div className="col-12 row mt-5 d-flex justify-content-between align-items-center">
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_NOME_EQUIPE"
                                    type="text"
                                    label="Nome"
                                    required
                                    defaultValue={
                                        getEquipeVendas?.DS_NOME_EQUIPE
                                    }
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="NR_CNPJ"
                                    type="number"
                                    label="CNPJ"
                                    defaultValue={getEquipeVendas?.NR_CNPJ}
                                    onChange={(e) => FormatterCPF}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_ESTADO"
                                    type="text"
                                    label="Estado"
                                    defaultValue={getEquipeVendas?.DS_ESTADO}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_BAIRRO"
                                    type="text"
                                    label="Bairro"
                                    defaultValue={getEquipeVendas?.DS_BAIRRO}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="NR_NUMERO"
                                    type="number"
                                    label="Numero"
                                    defaultValue={getEquipeVendas?.NR_NUMERO}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="NR_TELEFONE"
                                    type="number"
                                    label="Telefone"
                                    defaultValue={getEquipeVendas?.NR_TELEFONE}
                                ></UnForm.Input>
                            </div>
                        </div>
                        <div className="col-12 row mt-5 d-flex justify-content-between align-items-center">
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_EMAIL"
                                    label="Email"
                                    defaultValue={getEquipeVendas?.DS_EMAIL}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_NOME_FANTASIA"
                                    label="Nome Fantasia"
                                    defaultValue={
                                        getEquipeVendas?.DS_NOME_FANTASIA
                                    }
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_CEP"
                                    label="Cep"
                                    defaultValue={getEquipeVendas?.DS_CEP}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_CIDADE"
                                    label="Cidade"
                                    defaultValue={getEquipeVendas?.DS_CIDADE}
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_LOGRADOURO"
                                    label="Logradouro"
                                    defaultValue={
                                        getEquipeVendas?.DS_LOGRADOURO
                                    }
                                ></UnForm.Input>
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    name="DS_COMPLEMENTO"
                                    label="Complemento"
                                    defaultValue={
                                        getEquipeVendas?.DS_COMPLEMENTO
                                    }
                                ></UnForm.Input>
                            </div>
                        </div>
                        <div className="col-12 mt-5 d-flex align-items-center justify-content-center">
                            <div className="col-8">
                                <UnForm.Input
                                    name="DS_CRECI"
                                    label="Creci"
                                    defaultValue={getEquipeVendas?.DS_CRECI}
                                ></UnForm.Input>
                            </div>
                        </div>

                        <UnForm.SubmitButton
                            color="success"
                            wrapperClassName="w-100 mt-8"
                            className="w-100"
                            icon={faSave}
                            loading={
                                vincularEquipeLoading ||
                                atualizaEquipeVendasLoading
                            }
                            disabled={
                                vincularEquipeLoading ||
                                atualizaEquipeVendasLoading
                            }
                            loadingSize={"lg"}
                        >
                            Salvar
                        </UnForm.SubmitButton>
                    </div>
                    <hr />
                </UnForm>
            </div>
        </>
    );
}
